import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { GridContext, useGridContext } from "../grid-context";
import * as Styled from "./Row.styled";
export const GridRow = forwardRef((props, ref) => {
    const { breakpoints } = props;
    const breakpointContext = useGridContext(breakpoints);
    return breakpoints ? (_jsx(GridContext.Provider, { value: breakpointContext, children: _jsx(Styled.Row, { ref: ref, "data-testid": "GridRow", ...props, breakpoints: breakpointContext }) })) : (_jsx(Styled.Row, { ref: ref, "data-testid": "GridRow", ...props, breakpoints: breakpointContext }));
});
GridRow.displayName = "GridRow";
GridRow.defaultProps = Styled.rowDefaultProps;
